@for (item of details; track item) {
<div class="mb-4">
  <h2>{{item.label | translate}}</h2>
  @if (item.value) {
{{item.value}}
} @else {

    <div>
      {{'indicators.generic.noData' | translate}}
    </div>
  
}
  
</div>
}
